import { GoogleOAuthProvider } from "@react-oauth/google";
import ReactDOM from "react-dom/client";

import { AuthApplication } from "./auth-application";
import "./styles.css";

const defaultGoogleClientId = "937136485794-tkmuj3uvpjbl0e1n06avjnqhdb4u83sd.apps.googleusercontent.com";

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <GoogleOAuthProvider clientId={import.meta.env.VITE_GOOGLE_OAUTH_CLIENT_ID ?? defaultGoogleClientId}>
    <AuthApplication />
  </GoogleOAuthProvider>,
);
